import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Typography from '@material-ui/core/Typography';
import {Box} from "@material-ui/core";
import {Add, EventNote} from "@material-ui/icons";
import {WorkerDay} from "../redux/types";
import {format} from "date-fns";
import {OrderTimelineDisplay} from "../../calendar/OrderTimelineDisplay";
import {CreateOrderDialogForm} from "../form/CreateOrderDialogForm";
import {AvailabilityTimelineItem} from "../../calendar/AvailabilityTimelineItem";

const useStyles = makeStyles((theme) => ({
    orderColor: {
        backgroundColor: theme.palette.warning.light
    }
}));

interface WorkerDayTimelineComponentProps {
    workerDay: WorkerDay;
    worker: { id: string; name: string };
    dayDate: Date;
}

export default function CustomizedTimeline({workerDay, worker, dayDate}: WorkerDayTimelineComponentProps) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <CreateOrderDialogForm
                initialDate={new Date(workerDay.availability?.from || dayDate)}
                initialWorkerId={worker.id}
                buttonProps={{variant: 'text', startIcon: <Add/>, style: {width: 150, alignSelf: 'center'}}}
            />
            {workerDay.availability ?
                <Timeline align="left">
                    <AvailabilityTimelineItem availability={workerDay.availability} variant="from"/>
                    {workerDay.orders.filter(o => o.confirmed).map((order) => (
                        <React.Fragment>
                            <TimelineItem>
                                <TimelineOppositeContent>
                                    <Typography variant="body2" color="textSecondary">
                                        {format(order.estimatedFrom, "HH:mm")}
                                    </Typography>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot className={classes.orderColor}>
                                        <EventNote/>
                                    </TimelineDot>
                                    <TimelineConnector/>
                                </TimelineSeparator>
                                <TimelineContent>
                                    <OrderTimelineDisplay order={order}/>
                                </TimelineContent>
                            </TimelineItem>
                            <TimelineItem>
                                <TimelineOppositeContent>
                                    <Typography variant="body2" color="textSecondary">
                                        {format(order.estimatedTo, 'HH:mm')}
                                    </Typography>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot>
                                        <EventNote/>
                                    </TimelineDot>
                                    <TimelineConnector/>
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Box width={280}/>
                                </TimelineContent>
                            </TimelineItem>
                        </React.Fragment>
                    ))}
                    <AvailabilityTimelineItem availability={workerDay.availability} variant="to"/>
                </Timeline>
                : <div style={{width: 450, display: "flex", justifyContent: "center", paddingTop: 24}}>
                    {workerDay.orders.filter(o => o.confirmed).map((order) => (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <TimelineOppositeContent>
                                <Typography variant="body2" color="textSecondary">
                                    {format(order.estimatedFrom, "HH:mm")}
                                </Typography>
                            </TimelineOppositeContent>
                            <TimelineSeparator style={{marginRight: 16}}>
                                <TimelineDot className={classes.orderColor}>
                                    <EventNote/>
                                </TimelineDot>
                                <TimelineConnector/>
                            </TimelineSeparator>
                            <OrderTimelineDisplay order={order}/>
                        </div>
                    ))}
                </div>
            }
        </React.Fragment>
    );
}
